<template>
    <div class="auth-screen">
        <div class="auth-card">
            <img class="auth-logo" src="/logo.png" alt="Fytlix" />
            <h1 class="auth-title">{{ $t('setPasswordTitle') }}</h1>

            <template v-if="checking">
                <p class="auth-subtitle">{{ $t('checkingLink') }}</p>
                <div class="spinner" style="margin: 20px auto;"></div>
            </template>

            <template v-else-if="!valid">
                <div class="box-error">{{ $t('invalidToken') }}</div>
                <router-link class="btn btn-primary btn-block" :to="{ name: 'login' }">{{ $t('backToLogin') }}</router-link>
            </template>

            <template v-else-if="done">
                <div class="box-success">{{ $t('passwordSaved') }}</div>
                <router-link class="btn btn-primary btn-block btn-lg" :to="{ name: 'login' }">
                    <i class="fa-solid fa-right-to-bracket"></i> {{ $t('login') }}
                </router-link>
            </template>

            <template v-else>
                <p class="auth-subtitle">{{ email }}</p>
                <div v-if="error" class="box-error">{{ error }}</div>
                <form @submit.prevent="submit">
                    <label class="field">
                        <span class="field-label">{{ $t('newPassword') }}</span>
                        <input class="field-input" type="password" autocomplete="new-password" v-model="password" />
                    </label>
                    <label class="field">
                        <span class="field-label">{{ $t('repeatPassword') }}</span>
                        <input class="field-input" type="password" autocomplete="new-password" v-model="repeat" />
                    </label>
                    <button class="btn btn-primary btn-block btn-lg" type="submit" :disabled="!password || !repeat">
                        <i class="fa-solid fa-floppy-disk"></i> {{ $t('savePassword') }}
                    </button>
                </form>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SetPasswordView',
    data() {
        return {
            checking: true,
            valid: false,
            done: false,
            email: '',
            password: '',
            repeat: '',
            error: ''
        };
    },
    computed: {
        token() {
            return this.$route.params.token;
        }
    },
    async mounted() {
        // If a logged-in member opens a set-password link (e.g. from the in-app change flow), start clean.
        if (this.$store.getters.isAuthenticated) {
            this.$store.commit('reset');
        }
        const response = await this.$api.get('password/validate', { token: this.token }, { client: false });
        this.valid = response.success && response.data.valid === true;
        this.email = this.valid ? response.data.email : '';
        this.checking = false;
    },
    methods: {
        async submit() {
            this.error = '';
            if (this.password.length < 5) {
                this.error = this.$t('passwordTooShort');
                return;
            }
            if (this.password !== this.repeat) {
                this.error = this.$t('passwordsDontMatch');
                return;
            }
            const response = await this.$api.post('password/set', {
                token: this.token,
                password: this.password
            }, { client: false });

            if (response.success) {
                this.done = true;
            } else if (response.data && response.data.password === 'too_short') {
                this.error = this.$t('passwordTooShort');
            } else {
                this.valid = false;
            }
        }
    }
};
</script>
